
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square15 = createMeisterIcons("square-15", [["path",{"fill":"currentColor","d":"M9 3.75C6.114 3.75 3.75 6.114 3.75 9v2.25h7.5v-7.5zm3.75 0v7.5h7.5V9c0-2.886-2.364-5.25-5.25-5.25zm-1.5 9h-7.5V15c0 2.886 2.364 5.25 5.25 5.25h2.25zm1.5 7.5v-7.5h7.5V15c0 2.886-2.364 5.25-5.25 5.25zM2.25 9c0-3.714 3.036-6.75 6.75-6.75h6c3.714 0 6.75 3.036 6.75 6.75v6c0 3.714-3.036 6.75-6.75 6.75H9c-3.714 0-6.75-3.036-6.75-6.75z","key":"6d847f158a0be7efa2127aaa7678046e1e2c266a","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square15
  